import { Check, X } from 'lucide-react'

import { Reveal } from '@/components/ui/Reveal'

import { SectionLabel } from './HowItWorks'

const rows = [
  { feature: 'Real-time slot availability', others: 'Delayed', tc: 'Live', whatsapp: false },
  { feature: 'Instant online payment', others: true, tc: 'UPI / card', whatsapp: false },
  {
    feature: 'Booking confirmation',
    others: 'Email only',
    tc: 'Instant on WhatsApp',
    whatsapp: false,
  },
  { feature: 'No-show protection', others: false, tc: 'Deposit system', whatsapp: false },
  {
    feature: 'Owner revenue dashboard',
    others: 'Basic only',
    tc: 'Full analytics',
    whatsapp: false,
  },
  { feature: 'Recurring weekly slots', others: false, tc: 'Automated', whatsapp: false },
  { feature: 'Commission for players', others: 'Fees apply', tc: 'Always free', whatsapp: true },
]

type CellVal = boolean | string

export function ComparisonTable() {
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-12 py-20">
      <SectionLabel>Why TurfChale</SectionLabel>
      <Reveal delay={0.05}>
        <h2
          className="font-display font-bold leading-[1.1] tracking-tight mb-10"
          style={{
            color: 'var(--text)',
            fontSize: 'clamp(1.9rem,3.5vw,2.8rem)',
            letterSpacing: '-.5px',
            maxWidth: 520,
          }}
        >
          The smarter way to book
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <div
          className="overflow-x-auto rounded-2xl"
          style={{ border: '1px solid var(--lime-line)' }}
        >
          <table className="w-full border-collapse">
            <thead>
              <tr style={{ background: 'var(--bg3)', borderBottom: '1px solid var(--lime-line)' }}>
                <th
                  className="text-left px-6 py-4 text-[0.75rem] font-bold tracking-[0.08em] uppercase"
                  style={{ color: 'var(--text-dim)' }}
                >
                  Feature
                </th>
                <th
                  className="px-6 py-4 text-[0.75rem] font-bold tracking-[0.08em] uppercase text-center"
                  style={{ color: 'var(--text-dim)' }}
                >
                  WhatsApp / Calls
                </th>
                <th
                  className="px-6 py-4 text-[0.75rem] font-bold tracking-[0.08em] uppercase text-center relative"
                  style={{ background: 'rgba(184,236,60,.06)', color: 'var(--lime)' }}
                >
                  <span
                    className="absolute -top-3 left-1/2 -translate-x-1/2 text-[0.6rem] font-bold px-2 py-0.5 rounded-full whitespace-nowrap"
                    style={{ background: 'var(--lime)', color: 'var(--bg)' }}
                  >
                    ✦ Recommended
                  </span>
                  TurfChale
                </th>
                <th
                  className="px-6 py-4 text-[0.75rem] font-bold tracking-[0.08em] uppercase text-center"
                  style={{ color: 'var(--text-dim)' }}
                >
                  Other Apps
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr
                  key={row.feature}
                  style={{
                    borderBottom: i < rows.length - 1 ? '1px solid rgba(255,255,255,.04)' : 'none',
                  }}
                >
                  <td
                    className="px-6 py-4 text-[0.875rem] font-medium"
                    style={{ color: 'var(--text)' }}
                  >
                    {row.feature}
                  </td>
                  <td className="px-6 py-4 text-center">
                    <Cell val={row.whatsapp} />
                  </td>
                  <td
                    className="px-6 py-4 text-center"
                    style={{ background: 'rgba(184,236,60,.04)' }}
                  >
                    <Cell highlight val={row.tc} />
                  </td>
                  <td className="px-6 py-4 text-center">
                    <Cell val={row.others} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Reveal>
    </section>
  )
}

function Cell({ highlight = false, val }: { highlight?: boolean; val: CellVal }) {
  if (val === true)
    return (
      <span className="flex justify-center">
        <Check size={16} style={{ color: highlight ? 'var(--lime)' : 'var(--muted)' }} />
      </span>
    )
  if (val === false)
    return (
      <span className="flex justify-center">
        <X size={14} style={{ color: 'var(--text-dim)' }} />
      </span>
    )
  return (
    <span className="text-[0.82rem]" style={{ color: highlight ? 'var(--lime)' : 'var(--muted)' }}>
      {val}
    </span>
  )
}
